import React from "react";
import { Spinner, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import EmptyFeedCard from "../../../../../_uiComponents/EmptyFeedCard";

export default ({
  allAssignedJobs,
  assignedJobsLoading,
  onViewAppliedJobsClick,
  getJobUpdateIndex,
  kanbanBoardHandler,
}) => {
  return (
    <div className="dashboard-component-container border border-6  bg-white p-3 mt-4 h-100">
      <div className="d-flex align-items-center justify-content-between">
        <h4>Hiring Pipeline</h4>
        <div className="right d-flex align-items-center">
          <button
            onClick={onViewAppliedJobsClick}
            className="bg-transparent border-0 fs-14 text-primary font-weight-medium "
          >
            View All
          </button>
        </div>
      </div>
      <div className="dashboard-table border-0 mt-3">
        <Table borderless responsive className="mt-2 table-hiring-pipline">
          <thead className=" p-3  border-bottom-0">
            <tr className="text-nowrap text-center">
              <th className="font-weight-medium text-left">Jobs listing</th>
              <th className="font-weight-medium">Applied</th>
              <th className="font-weight-medium">Assessment</th>
              <th className="font-weight-medium">Interview</th>
              <th className="font-weight-medium">Offer</th>
              <th className="font-weight-medium">Hired</th>
              <th className="font-weight-medium">Rejected</th>
            </tr>
          </thead>
          <tbody className="px-4 text-center text-grey-4 text-capitalize bg-grey-4">
            {assignedJobsLoading ? (
              <tr>
                <td colSpan="7">
                  <div className="d-flex justify-content-center align-items-center p-4">
                    <Spinner animation="border" variant="primary" />
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {allAssignedJobs?.results &&
                Array.isArray(allAssignedJobs?.results) &&
                allAssignedJobs?.results.length ? (
                  <>
                    {allAssignedJobs?.results &&
                      Array.isArray(allAssignedJobs?.results) &&
                      allAssignedJobs.results.map((item) => (
                        <tr className="rounded-lg p-4">
                          <td
                            className="text-left cursor-pointer font-weight-medium mr-4"
                            onClick={() => {
                              kanbanBoardHandler(item?.id);
                            }}
                          >
                            <h4 className="text-dark mb-1">{item?.title}</h4>
                            <p className="text-dark">
                              <span className="text-grey-4">
                                Total Application:{" "}
                              </span>
                              {item?.total_candidates}
                            </p>
                          </td>
                          <td>
                            {getJobUpdateIndex(
                              item?.candidates_at_different_stages
                            ) < 1 ? (
                              <span className="pipeline-label rounded-sm">
                                &nbsp;
                              </span>
                            ) : (
                              <span
                                className={`pipeline-label rounded-sm label-blue ${
                                  getJobUpdateIndex(
                                    item?.candidates_at_different_stages
                                  ) > 1
                                    ? "opacity-full"
                                    : ""
                                }`}
                              >
                                {item?.candidates_at_different_stages &&
                                  item.candidates_at_different_stages
                                    .applied}{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            {getJobUpdateIndex(
                              item?.candidates_at_different_stages
                            ) < 2 ? (
                              <span className="pipeline-label rounded-sm">
                                &nbsp;
                              </span>
                            ) : (
                              <span
                                className={`pipeline-label rounded-sm label-light-green ${
                                  getJobUpdateIndex(
                                    item?.candidates_at_different_stages
                                  ) > 2
                                    ? "opacity-full"
                                    : ""
                                }`}
                              >
                                {item?.candidates_at_different_stages &&
                                  item.candidates_at_different_stages
                                    .assessment}{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            {getJobUpdateIndex(
                              item?.candidates_at_different_stages
                            ) < 3 ? (
                              <span className="pipeline-label rounded-sm">
                                &nbsp;
                              </span>
                            ) : (
                              <span
                                className={`pipeline-label rounded-sm label-voilet ${
                                  getJobUpdateIndex(
                                    item?.candidates_at_different_stages
                                  ) > 3
                                    ? "opacity-full"
                                    : ""
                                }`}
                              >
                                {item?.candidates_at_different_stages &&
                                  item.candidates_at_different_stages
                                    .interview}{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            {getJobUpdateIndex(
                              item?.candidates_at_different_stages
                            ) < 4 ? (
                              <span className="pipeline-label rounded-sm">
                                &nbsp;
                              </span>
                            ) : (
                              <span
                                className={`pipeline-label rounded-sm label-yellow ${
                                  getJobUpdateIndex(
                                    item?.candidates_at_different_stages
                                  ) > 4
                                    ? "opacity-full"
                                    : ""
                                }`}
                              >
                                {item?.candidates_at_different_stages &&
                                  item.candidates_at_different_stages
                                    .offer}{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            {getJobUpdateIndex(
                              item?.candidates_at_different_stages
                            ) < 5 ? (
                              <span className="pipeline-label rounded-sm">
                                &nbsp;
                              </span>
                            ) : (
                              <span
                                className={`pipeline-label rounded-sm label-green ${
                                  getJobUpdateIndex(
                                    item?.candidates_at_different_stages
                                  ) > 5
                                    ? "opacity-full"
                                    : ""
                                }`}
                              >
                                {item?.candidates_at_different_stages &&
                                  item.candidates_at_different_stages
                                    .hired}{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            {getJobUpdateIndex(
                              item?.candidates_at_different_stages
                            ) < 6 ? (
                              <span className="pipeline-label rounded-sm">
                                &nbsp;
                              </span>
                            ) : (
                              <span
                                className={`pipeline-label rounded-sm label-red ${
                                  getJobUpdateIndex(
                                    item?.candidates_at_different_stages
                                  ) > 6
                                    ? "opacity-full"
                                    : ""
                                }`}
                              >
                                {item?.candidates_at_different_stages &&
                                  item.candidates_at_different_stages
                                    .rejected}{" "}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <EmptyFeedCard
                        src="/assets/images/hiring-pipeline-empty-state-icon.svg"
                        message={"No Candidates in the Hiring Pipeline"}
                        description={
                          "The hiring pipeline is currently empty. Keep an eye on this space for candidates as they progress through the recruitment process."
                        }
                        btnText={"Discover New Candidates"}
                        link={"/all-candidates"}
                      />
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};
